import Equipe from "@/firebase/tirage2/Equipe.js"
import Joueur from "@/firebase/tirage2/Joueur.js"
export default class Partie {
    equipes=[];
    equipesSave=[];
    numeroRestantJoueurs=[];
    options= null;
    indexPartie = null;
    joueurs = null;
    joueursSave = null;
    reinit = 0;
    error = false;
    nbError = 0;
    nbJoueurInError = 1000;
    complementaire = false;
    state = null;
    constructor(indexPartie, options, numeroRestantJoueurs, joueurs) {
        this.numeroRestantJoueurs = numeroRestantJoueurs;
        this.options = options;
        this.indexPartie = indexPartie;
        this.joueurs = joueurs
    }    
    get() {
        return {
            state: "WAITING",
            equipes: this.equipes
        }
    }
    verifIsRemplacable(vs, indiceEquipeFind, joueurCible, objectEquipe, joueur, forcage) {
        // on test d'abord si le joueur appartenant à l'équipe en cours n'est pas une triplette
        // et on teste si le joueur cible a déjà joué une trpilette
        // si une des conditions est ok alors on peut aller à la condition suivante
        var vs_vs = vs == "joueurs" ? 'contre' : 'joueurs';
        if (vs == "joueurs") {
            var nbJoueurs = this.equipes[objectEquipe.indiceEquipe].getNbJOUEURS()
            var nbJoueursContre = this.equipes[objectEquipe.indiceEquipe].getNbCONTRE()
        }
        else {
            var nbJoueurs = this.equipes[objectEquipe.indiceEquipe].getNbCONTRE()
            var nbJoueursContre = this.equipes[objectEquipe.indiceEquipe].getNbJOUEURS()
        }
        
        var returnVerif = false;

        if (nbJoueurs<3 || !joueurCible.playTriplette(vs, this.indexPartie)) {
            // du coup on teste si l'équipe qu'on a trouvé n'est pas triplette
            // si le joueur en cours a déjà joué une triplette
            // si unde des conditions est ok alors c bon   
            if (this.equipes[indiceEquipeFind].getNb(vs)<3 
                || !joueur.playTriplette(vs, this.indexPartie)) {
                if (forcage==1) {
                    // on refait pareil qu'au dessus mais on regarde avec l'équipe adverse !
                    if (nbJoueursContre<3 
                        || !joueurCible.playTriplette(vs_vs, this.indexPartie)) {
                            if (this.equipes[indiceEquipeFind].getNb(vs_vs)<3 
                                || !joueur.playTriplette(vs_vs, this.indexPartie)) {
                                    returnVerif = true;
                            }
                    }
                }
                else // if force
                    returnVerif = true;
                }
        }
       
        return returnVerif;
    }
    isRemplacabLe(joueur, forcage) {
        var findEquipe = null;
        var vsFinal = null;
        var tabVS = [];
        var joueurJ = null;
        var indiceEquipeFind = null
        this.equipes.forEach((equipe, indiceEquipe)=>{
                
                if (findEquipe == null) {
                    if (Joueur.validAMI(joueur, equipe.dataJoueurs.joueurs, forcage) 
                    && Joueur.validCONTRE(joueur, equipe.dataJoueurs.contre, forcage)) {
                        
                            findEquipe = equipe.dataJoueurs;
                            indiceEquipeFind = indiceEquipe
                            tabVS.push("joueurs");
                       
                        
                    }
                    if (Joueur.validAMI(joueur, equipe.dataJoueurs.contre, forcage) 
                    && Joueur.validCONTRE(joueur, equipe.dataJoueurs.joueurs, forcage)) { 
                             indiceEquipeFind = indiceEquipe
                            findEquipe = equipe.dataJoueurs;
                            tabVS.push("contre");
                        
                    }
                }
                
                
                if ( findEquipe != null &&  joueurJ == null) {
                    // Maintenant on va tenter de voir quel est le joueur parmis l'équipe trouvé est compataible avec les joueurs de l'équipe
                  
                    var objectEquipe   = Joueur.findEquipe(this.equipes, joueur);
                    
                    if (objectEquipe.indiceEquipe != null) {
                    var equipeDuJoueur = this.equipes[objectEquipe.indiceEquipe].dataJoueurs;
                        tabVS.forEach(vs=>{
                            var vs_vs = vs == 'joueurs' ? 'contre' : 'joueurs';
                            for (var joueurJ_search in findEquipe[vs]) {
                                // on a va regarder si les joueurs de l'équipe du joueur à remplacer est compatible avec le joueur trouver !
                                var joueurCible = findEquipe[vs][joueurJ_search];
                                if (joueurCible != null) {
                                    if (joueurJ == null ) {
                                        var validGG = true;
                                        if (typeof(this.options.GG) != "undefined" && this.options.GG) {
                                            if (this.indexPartie>0) {
                                                var indexPartie = this.indexPartie - 1;
                                                validGG = this.joueurs[joueur.numero].gagnesByPartie[indexPartie] ==  this.joueurs[joueurCible.numero].gagnesByPartie[indexPartie];
                                            }
                                        }
                                    if (validGG) {

                                   
                                    if (objectEquipe.vs == "joueurs" && Joueur.validAMI(joueurCible, equipeDuJoueur.joueurs, forcage) 
                                            && Joueur.validCONTRE(joueurCible, equipeDuJoueur.contre, forcage)) {
                                        // on a trouvé le joueur 
                                        if (this.options.nbJoueursParEquipe == 2) {
                                            if (this.verifIsRemplacable("joueurs", indiceEquipeFind, joueurCible, objectEquipe, joueur, forcage)) { 
                                                        joueurJ = joueurJ_search;
                                                        vsFinal = vs;
                                            }       
                                        }
                                        else if (this.options.nbJoueursParEquipe == 3) {
                                            if (this.equipes[objectEquipe.indiceEquipe].getNbJOUEURS()==3 || !joueurCible.playDoublette("joueurs", this.indexPartie)) {
                                                if (this.equipes[indiceEquipeFind].getNb(vs)==3 || !joueur.playDoublette("joueurs", this.indexPartie)) {
                                                            joueurJ = joueurJ_search;
                                                            vsFinal = vs;
                                                }
                                            }   
                                        }
                                    }
                                    if (objectEquipe.vs == "contre" && Joueur.validAMI(joueurCible, equipeDuJoueur.contre, forcage) 
                                                && Joueur.validCONTRE(joueurCible, equipeDuJoueur.joueurs, forcage)) { 
                                        // on a trouvé le joueur 
                                        if (this.options.nbJoueursParEquipe == 2) {
                                            if (this.verifIsRemplacable("contre", indiceEquipeFind, joueurCible, objectEquipe, joueur, forcage)) { 
                                                joueurJ = joueurJ_search;
                                                vsFinal = vs;
                                            }  
                                        }
                                        else if (this.options.nbJoueursParEquipe == 3) {
                                            if (this.equipes[objectEquipe.indiceEquipe].getNbCONTRE()==3 || !joueurCible.playDoublette("joueurs",this.indexPartie)) {
                                                if (this.equipes[indiceEquipeFind].getNb(vs)==3 || !joueur.playDoublette("joueurs", this.indexPartie)) {
                                                    joueurJ = joueurJ_search;
                                                    vsFinal = vs;
                                                }
                                            }
                                        }
                                        
                                    }
                                    }
                                }
                                }
                                
                            }
                        })
                    }
                        if (joueurJ == null) {
                            findEquipe = null;
                            tabVS = [];
                            vsFinal = null;
                            joueurJ = null;
                            indiceEquipeFind = null;
                        } 
                }
            }) 
        
        var objectJoueurReturn = {
            indiceEquipe: indiceEquipeFind,
            vs: vsFinal,
            joueur: joueurJ
        }
        return objectJoueurReturn;
    }
    
    traiterError () {
        
        this.joueurs.forEach((joueur, indiceJoueur)=>{
            if (joueur.isErrorInPartie(this.indexPartie)) {
                   
                    var objectRemplacer = this.isRemplacabLe(joueur, 0);
                    if (objectRemplacer.indiceEquipe == null) {
                        var objectRemplacer = this.isRemplacabLe(joueur, 1);
                       
                        // on force les joueurs peuvent tomber contre 2 triplettes
                    }
                    if (objectRemplacer.indiceEquipe == null) {
                        var objectRemplacer = this.isRemplacabLe(joueur, 2);
                        
                        // on force les joueurs peuvent tomber contre 2 fois contre un adversaire
                    }
                    if (objectRemplacer.indiceEquipe == null) {
                        var objectRemplacer = this.isRemplacabLe(joueur, 3);
                       
                        // on force les joueurs peuvent rencontrer contre 2 fois un coequippier
                    }
                    if (objectRemplacer.indiceEquipe != null) {
                       
                        var joueurTempo = this.joueurs[this.equipes[objectRemplacer.indiceEquipe].dataJoueurs[objectRemplacer.vs][objectRemplacer.joueur].numero];
                        
                        var joueurAREMPLACER = new Joueur (this.options, joueurTempo.numero, joueurTempo.parties, joueurTempo.amis, joueurTempo.contre, joueurTempo.error, joueurTempo.gagnes, joueurTempo.gagnesByPartie)
                        this.joueurs[joueurAREMPLACER.numero] = joueurAREMPLACER;
                        var objectEquipe   = Joueur.findEquipe(this.equipes, joueur);
                        joueur.error = false;
                        joueur.errorDetail = {};
                        this.equipes[objectRemplacer.indiceEquipe].dataJoueurs[objectRemplacer.vs][objectRemplacer.joueur] = joueur;
                        this.equipes[objectEquipe.indiceEquipe].dataJoueurs[objectEquipe.vs][objectEquipe.joueur] = this.joueurs[joueurAREMPLACER.numero];
                        
                        this.equipes[objectRemplacer.indiceEquipe].reinitJoueurs(this.joueurs);
                        this.equipes[objectEquipe.indiceEquipe].reinitJoueurs(this.joueurs);
                    }
                  
                   
                    

            }
        })
    }
    winJoueursByDefault(equipe, indexEquipe, indexPartie, options, numeroRestantJoueurs, joueurs) {
        var indexEquipeWin = indexEquipe;
        for (var key in equipe.dataJoueurs)
                for (var joueur in equipe.dataJoueurs[key]) {
                    if (equipe.dataJoueurs[key][joueur] != null) {
                        var nouvelEquipe  = new Equipe (indexPartie, options, numeroRestantJoueurs, joueurs);
                        nouvelEquipe.dataJoueurs.joueurs.J1 = equipe.dataJoueurs[key][joueur];
                        
                        if (!options.addPartie) {
                            nouvelEquipe.score.joueurs = this.options.ifNotFound.win;
                            nouvelEquipe.score.contre = this.options.ifNotFound.lose;
                        }
                        else {
                            
                            nouvelEquipe.state="FINISH"
                        }
                        nouvelEquipe.reinitJoueurs(this.joueurs);
                        this.equipes[indexEquipeWin] = nouvelEquipe;
                        indexEquipeWin++;
                    }
                }
        // pour bien il faudrait vérifier si le joueur J1 n'a pas déjà été tiré pour une partie à blanc
        // si non on laisse si oui il faudrait trouver un autre joueur de la partie tout en vérifiant qu'il n'est pas tomber dessus
        
    }
    init() {
      
        var numeroRestantJoueurs = this.numeroRestantJoueurs;
     
        if (this.options.nbJoueursParEquipe == 1) {
            var nombreEquipes = this.numeroRestantJoueurs.length / 2;
        }
        else if (this.options.nbJoueursParEquipe == 2) {
            var nombreEquipes = this.numeroRestantJoueurs.length / 4;
        }
        else if (this.options.nbJoueursParEquipe == 3) {
            var nombreEquipes = this.numeroRestantJoueurs.length / 3;
        }
     
        this.nbError = 0;
        this.equipes = [];
        var lastEquipe = false;
        
        for (var indexEquipe = 0; indexEquipe < nombreEquipes ; indexEquipe++) {
            if (!lastEquipe) {
                var equipe = new Equipe (this.indexPartie, this.options, numeroRestantJoueurs, this.joueurs);
                
                equipe.init();
               
                // ICI on vérifie si l'équipe est complète !!!!
                var nbJOUEURS = equipe.getNbJOUEURS();
                var NbCONTRE  = equipe.getNbCONTRE();
                
             // EN INDIVIDUEL
            
            if (this.options.nbJoueursParEquipe == 1) {
                
                if (NbCONTRE == 0) {
                   
                    if (!this.options.allEquipePlay) {
                        this.winJoueursByDefault(equipe, indexEquipe, this.indexPartie, this.options, numeroRestantJoueurs, this.joueurs);
                    }
                    else {
                       
                        //if (this.options.mode == 'FORME') {
                        if (this.options.mode=='FORME') {
                            this.winJoueursByDefault(equipe, indexEquipe, this.indexPartie, this.options, numeroRestantJoueurs, this.joueurs);
                        }   
                        else if (equipe.dataJoueurs.joueurs.J1 != null) {
                            numeroRestantJoueurs.push(equipe.dataJoueurs.joueurs.J1.numero)
                        }
                        //}
                    }
                }
                else {
                  
                    this.equipes[indexEquipe] = equipe;
                }
            }
            // SI ON FAIT DES DOUBLETTE
            else if (this.options.nbJoueursParEquipe == 2) {
                if ((nbJOUEURS != this.options.nbJoueursParEquipe) || (NbCONTRE != this.options.nbJoueursParEquipe)) {
                    // c'est simple on doit replacer créer autant de tripplettes avec les joueurs de cette équipe
                    // & ne pas l'ajouter 
                    
                    if (!this.options.allEquipePlay) {
                        this.winJoueursByDefault(equipe, indexEquipe, this.indexPartie, this.options, numeroRestantJoueurs, this.joueurs);
                    }
                    else {
                   
                    for (var key in equipe.dataJoueurs)
                        for (var joueur in equipe.dataJoueurs[key]) {
                            if (equipe.dataJoueurs[key][joueur] != null) {
                                try {
                                    var objectEquipe = Equipe.findEquipeForTriplette (equipe.dataJoueurs[key][joueur], this.equipes); // donne moi l'indice equipe & key & joueur
                                    if (objectEquipe.key==null) {
                                        numeroRestantJoueurs.push(equipe.dataJoueurs[key][joueur].numero);
                                    }
                                    else {
                                        this.equipes[objectEquipe.indexEquipe].dataJoueurs[objectEquipe.key][objectEquipe.joueur] = equipe.dataJoueurs[key][joueur];
                                        this.equipes[objectEquipe.indexEquipe].reinitJoueurs(this.joueurs);
                                    // et là il faut reinitialiser les tableau des joueurs                          
                                    }
                                }
                                catch {
                                    numeroRestantJoueurs.push(equipe.dataJoueurs[key][joueur].numero);
                                }
                            }
                        }
                    }
                }
                else {
                    this.equipes[indexEquipe] = equipe;
                    //to maj 10/10
                    this.equipes[indexEquipe].reinitJoueurs(this.joueurs);
                }
            }
            else if (this.options.nbJoueursParEquipe == 3) {
                
                if (equipe.dataJoueurs["joueurs"]["J1"] == null) 
                        lastEquipe = true;
                else if ((nbJOUEURS != this.options.nbJoueursParEquipe) || (NbCONTRE != this.options.nbJoueursParEquipe)) {
                    // TROUVE DES JOUEURS POUR COMPLETER L'EQUIPE
                    if (!this.options.allEquipePlay) {
                        this.winJoueursByDefault(equipe, indexEquipe, this.indexPartie, this.options, numeroRestantJoueurs, this.joueurs);
                    }
                    else {
                        lastEquipe = true;
                    for (var key in equipe.dataJoueurs) {
                        for (var joueurLoop in equipe.dataJoueurs[key]) {
                           
                            if (equipe.dataJoueurs[key][joueurLoop] == null && (key!="contre" || joueurLoop!="J3")) {
                                
                                var objectEquipe = Equipe.findJoueurToCompleteTriplette(equipe, this.equipes);
                               
                               
                                var joueurTempo = this.equipes[objectEquipe.indexEquipe].dataJoueurs[objectEquipe.key][objectEquipe.joueur];
                                
                                
                                var joueurNew = new Joueur (this.options, 
                                        joueurTempo.numero, 
                                        joueurTempo.parties, 
                                        joueurTempo.amis, 
                                        joueurTempo.contre, 
                                        joueurTempo.error);
                                
                                equipe.dataJoueurs[key][joueurLoop] = joueurNew;
                               
                                equipe.reinitJoueurs(this.joueurs);
                               
                                this.equipes[indexEquipe] = equipe;
                                this.equipes[objectEquipe.indexEquipe].dataJoueurs[objectEquipe.key][objectEquipe.joueur] = null;
                                this.equipes[objectEquipe.indexEquipe].reinitJoueurs(this.joueurs);
                            }
                            else {
                                this.equipes[indexEquipe] = equipe;
                            }
                        }
                    }
                    }
                    
                }
                else {          
                    this.equipes[indexEquipe] = equipe;
                }
                    
             }
            }
            
            
            
        }
        
        // DANS LE CAS DES TRIPLETTES SI ON A 4 JEUX Où IL Y A UNE TRIPLETTE CONTRE UNE DOUBLETTE
        // ALORS ON PREND LES 4 JOUEURS DES TRIPLETTE POUR EN FAIRE DES DOUBLETTES
      
        if (this.options.nbJoueursParEquipe == 3 && this.options.allEquipePlay) {
            
            for (var indexEquipe = 0; indexEquipe < this.equipes.length ; indexEquipe++) {
                var equipe = this.equipes[indexEquipe];
                var changeOnJoueurs = equipe.getNbCONTRE()==2 && equipe.getNbJOUEURS()==3;
                var changeOnContre = equipe.getNbCONTRE()==3 && equipe.getNbJOUEURS()==2;
                if (changeOnContre || changeOnJoueurs) {
                   
                    if (changeOnJoueurs) {
                        var key = "contre";
                    }
                    else {
                        var key = "joueurs";
                    }
                    var key2 = null;
                    // faut regarder si dans les autres equipes on peut affecter un joueur
                    var indexCible = null;
                    for (var indexEquipe2 = indexEquipe+1; indexEquipe2 < this.equipes.length ; indexEquipe2++) {
                        
                        var equipe2 = this.equipes[indexEquipe2];
                        if (key2==null && equipe2.getNbCONTRE()==2 && equipe2.getNbJOUEURS()==3) {
                            // ON FAIT LA CHIRURGIE sur JOUEURS
                            // l'équipe 2 ce sera une doublette contre une doublette
                            key2 = "joueurs";
                            indexCible = indexEquipe2;
                         
                        }
                        if (key2==null && equipe2.getNbCONTRE()==3 && equipe2.getNbJOUEURS()==2) {
                            // ON FAIT LA CHIRURGIE sur CONTRE
                            // l'équipe 2 ce sera une doublette contre une doublette
                            key2 = "contre";
                           
                            indexCible = indexEquipe2;
                        }
                    }
                    
                    if (key2 != null && indexCible!=null) { //  ca veut dire qu'on a trouvé on peut procéder à la chirurgie
                        
                        var joueur = equipe.getJoueurNull(key);
                        var joueur2 = this.equipes[indexCible].getJoueurNotNull(key2);
                        var joueurASup = this.equipes[indexCible].dataJoueurs[key2][joueur2];
                        var joueur2Object = new Joueur (this.options, 
                            joueurASup.numero, joueurASup.parties, joueurASup.amis, joueurASup.contre, 
                            joueurASup.error, joueurASup.gagnes, joueurASup.gagnesByPartie);
                        
                        this.equipes[indexCible].dataJoueurs[key2][joueur2] = null;
                        this.equipes[indexCible].reinitJoueurs(this.joueurs);
                        this.equipes[indexEquipe].dataJoueurs[key][joueur] = joueur2Object;
                        equipe.reinitJoueurs(this.joueurs);
                    }
                      
                }
            }
        }
        

           
        this.reinitEquipes();
        var pointJoueursError = this.checkError();
        var maxPointJoueursError = Number.MAX_VALUE;
        var indiceTraitement = 0;
        var equipesSave = [];
        //equipesSave = JSON.parse(JSON.stringify(this.equipes));
        while (pointJoueursError != 0 && indiceTraitement<1) {
            this.traiterError();
            indiceTraitement++;
            pointJoueursError = this.checkError();
          
        }
        
        //this.equipes = JSON.parse(JSON.stringify(equipesSave));
        //pointJoueursError = this.checkError();
        this.nbError = pointJoueursError;
    }
    reinitEquipes() {
        this.equipes.forEach(equipe=>{
            equipe.reinitJoueurs(this.joueurs);
        })
    }
    checkErrorGG(indiceEquipe, indiceEquipeToChange, type) {
     
        if (typeof(indiceEquipe)=="undefined")
            indiceEquipe=this.equipes.length-1;
        if (typeof(type)=="undefined")
            type="contre";
        
        if (this.equipes[indiceEquipe].dataJoueurs[type].J1!=null)
            var numeroContre = this.equipes[indiceEquipe].dataJoueurs[type].J1.numero;
      
        if (this.equipes[indiceEquipe].checkErrorFormeGG(numeroContre, "joueurs")) {
            // il faut changer le numeroContre !!!!
            var bool = true;
            var typeFind = "joueurs"
            var indiceFind;
            indiceFind = indiceEquipe;
            while (bool) {
                indiceFind = indiceFind-1;
               
                if (indiceFind<0) {
                    bool = false;
                }
                else {
                    typeFind = "contre"
                    bool = this.equipes[indiceFind].checkErrorFormeGG(numeroContre, "joueurs");
                  
                    if (!bool) {
                        // ca veut dire qu'on n'a pas d'erreur mais il faut maintenant si le numero trouvé est compatible avec le numero qu'on a en cours
                        if (this.equipes[indiceFind].dataJoueurs[typeFind].J1!=null) {
                            var numeroTrouve = this.equipes[indiceFind].dataJoueurs[typeFind].J1.numero;
                            bool = this.equipes[indiceEquipe].checkErrorFormeGG(numeroTrouve, "joueurs");
                        }
                        else
                            bool = true;
                    }
                    if (bool) {
                        typeFind = "joueurs";
                        bool = this.equipes[indiceFind].checkErrorFormeGG(numeroContre, "contre");
                       
                        if (!bool) {
                            // ca veut dire qu'on n'a pas d'erreur mais il faut maintenant si le numero trouvé est compatible avec le numero qu'on a en cours
                            if (this.equipes[indiceFind].dataJoueurs[typeFind].J1!=null) {
                                var numeroTrouve = this.equipes[indiceFind].dataJoueurs[typeFind].J1.numero;
                                bool = this.equipes[indiceEquipe].checkErrorFormeGG(numeroTrouve, "joueurs");
                            }
                            else
                                bool = true;
                        }
                    }
                }
            }
            // Bon bah on peut changer...
            if (indiceFind!=-1) {
                var equipeSave = JSON.parse(JSON.stringify(this.equipes[indiceEquipe].dataJoueurs["contre"]))
                this.equipes[indiceEquipe].dataJoueurs["contre"] = JSON.parse(JSON.stringify(this.equipes[indiceFind].dataJoueurs[typeFind]));
                this.equipes[indiceFind].dataJoueurs[typeFind] = equipeSave;
            }
        }
        else if (indiceEquipe!=0) {
            return this.checkErrorGG(indiceEquipe-1);
        }
        else {
            return null;
        }
    }
    checkError () {
        var pointJoueurInError = 0;
        this.error = false;
       
        this.joueurs.forEach(joueur=>{
            
            pointJoueurInError = joueur.checkError() + pointJoueurInError;
        })
      
        this.error =  pointJoueurInError != 0; 
        return pointJoueurInError
    }
    checkNewError() {
        var tabJoueurs = [];
        var triplette = [];
        this.parties.forEach((partie, indexPartie)=>{
            if (typeof(tabJoueurs[indexPartie]) == "undefined")
                tabJoueurs[indexPartie] = [];
            for (var key in partie.equipe.dataJoueurs) {
                if (typeof(tabJoueurs[indexPartie][key]) == "undefined")
                    tabJoueurs[indexPartie][key] = [];
                for (var joueur in partie.equipe.dataJoueurs[key]) {
                    if (partie.equipe.dataJoueurs[key][joueur]!=null) {
                        var numero = partie.equipe.dataJoueurs[key][joueur].numero;
                        tabJoueurs[indexPartie][key].push(numero);
                    }
                }
            }
        })
        
        
    }
}